<div class="logs m-sm-30">
  <app-breadcrumb></app-breadcrumb>
  <div class="mb-8">
    <div class="text-2xl mb-2 text-white leading-snug">
      Your Prysm Process' Logs
    </div>
    <p class="m-0 text-muted text-base leading-snug">
      Stream of logs from both the beacon node and validator client
    </p>
  </div>
  <div class="flex flex-wrap md:flex-no-wrap gap-6">
    <div class="w-full md:w-2/3">
      <app-logs-stream [messages]="validatorMessages" title="Validator Client"></app-logs-stream>
      <div class="py-3"></div>
      <app-logs-stream [messages]="beaconMessages" title="Beacon Node"></app-logs-stream>
    </div>
    <div class="w-full md:w-1/3">
      <mat-card class="bg-paper" *ngIf="(logMetrics$ | async) as metrics">
        <div class="card-title mb-8 text-lg text-white">Log Percentages</div>
        <div class="mb-6">
          <div>
            <mat-progress-bar mode="determinate" [value]="metrics.percentInfo" color="primary"></mat-progress-bar>
          </div>
          <div class="my-2 text-muted">
            <small>{{metrics.percentInfo}}% Info Logs</small>
          </div>
        </div>
        <div class="mb-6">
          <div>
            <mat-progress-bar mode="determinate" [value]="metrics.percentWarn" color="accent"></mat-progress-bar>
          </div>
          <div class="my-2 text-muted">
            <small>{{metrics.percentWarn}}% Warn Logs</small>
          </div>
        </div>
        <div class="mb-6">
          <div>
            <mat-progress-bar mode="determinate" [value]="metrics.percentError" color="warn"></mat-progress-bar>
          </div>
          <div class="my-2 text-muted">
            <small>{{metrics.percentError}}% Error Logs</small>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>